class AppConfig {
    static ApiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    static PfqBaseUrl = process.env.REACT_APP_PFQ_BASE_URL;

}

export default AppConfig;